export type COMPANY_TYPE =
  | 'FAIR_COMPENSATION'
  | 'LIVING_WELFARE'
  | 'CAPABLE'
  | 'IN_HOUSE_HARMONY'
  | 'SELF_REGULATION'
  | 'STABLE'
  | 'FULL_OF_COMPLIMENTS'
  | 'GOOD_LEADER'
  | 'GROWING_SUPPORT'
  | 'FAIR_EVALUATION'
  | 'COMMUNICATION'
  | 'HIGH_SATISFACTION'
  | 'PROUD'
  | 'SOCIAL'
  | 'ETHICAL';

export interface ICultureData {
  title: string;
  subTitle: string;
  contents: string;
}

export const cultureCardData: Record<COMPANY_TYPE, ICultureData> = {
  FAIR_COMPENSATION: {
    title: '공정보상 기업',
    subTitle: '일한 만큼 받는',
    contents: '성과를 낸 만큼 확실하게 보상을 주는 곳에서 더 동기부여를 받을 수 있습니다.',
  },
  LIVING_WELFARE: {
    title: '생활복지 기업',
    subTitle: '업무 집중도 쭉쭉!',
    contents: '안정적으로 내 생활을 유지할 수 있도록 다양한 복지를 주는 기업을 선호합니다.',
  },
  CAPABLE: {
    title: '능력자多 기업',
    subTitle: '동료가 곧 복지!',
    contents: '일을 잘하는 동료가 많은 곳에서 동기부여를 받아 업무에 더 몰입할 수 있습니다.',
  },
  IN_HOUSE_HARMONY: {
    title: '사내화합 기업',
    subTitle: '동료 친밀도가 뿜뿜!',
    contents: '동료 간의 친밀도가 높고 사내 동호회가 활발한 곳에서 더 잘 적응합니다.',
  },
  SELF_REGULATION: {
    title: '자율문화 기업',
    subTitle: '눈치 볼 필요 없는',
    contents: '유연한 분위기를 가지고 자율적으로 업무를 할 수 있는 곳에서 높은 집중도를 보입니다.',
  },
  STABLE: {
    title: '안정적인 기업',
    subTitle: '평생 함께하고 싶은',
    contents: '고용 안정성이 보장되어 오랫동안 일할 수 있는 곳을 좋아합니다.',
  },
  FULL_OF_COMPLIMENTS: {
    title: '칭찬가득 기업',
    subTitle: '서로를 존중해주는',
    contents: '동료 간 인정과 존중을 서로서로 잘해주는 곳에서 더 에너지를 받습니다.',
  },
  GOOD_LEADER: {
    title: '리더좋은 기업',
    subTitle: '보스가 아닌 리더!',
    contents: '믿음직한 리더와 함께 할 때 더 높은 성과를 낼 수 있습니다.',
  },
  GROWING_SUPPORT: {
    title: '성장지원 기업',
    subTitle: '매일 쓰는 성장연대기',
    contents: '자기개발을 장려하고 관련된 프로그램이 잘 갖춰져 있는 곳에서 만족감을 느낍니다.',
  },
  FAIR_EVALUATION: {
    title: '공정평가 기업',
    subTitle: '능력으로 승부 보는',
    contents: '직급이나 연차보다는 성과로 공정하게 평가받을 수 있는 곳에서 열정적으로 임합니다.',
  },
  COMMUNICATION: {
    title: '소통하는 기업',
    subTitle: '함께 공유 공감하는',
    contents: '구성원과 함께 공유 공감하는 소통체계가 잘 갖춰진 곳을 선호합니다.',
  },
  HIGH_SATISFACTION: {
    title: '만족도 ↑ 기업',
    subTitle: '자존감이 샘솟는',
    contents: '다른 어떤 것보다 회사에 대한 보람과 만족도를 높게 느끼고자 합니다.',
  },
  PROUD: {
    title: '자랑스런 기업',
    subTitle: '모두가 인정하는',
    contents: '인지도가 높고 많은 사람들이 알고 있는 기업에서 만족감을 느낍니다.',
  },
  SOCIAL: {
    title: '사회적 기업',
    subTitle: '좋은 세상을 만드는',
    contents: '다양한 이익환원, 공익활동, 봉사 프로그램 등 사회적인 활동을 중요하게 생각합니다.',
  },
  ETHICAL: {
    title: '윤리적인 기업',
    subTitle: '정직이 곧 생명!',
    contents: '정직함을 높은 가치로 여겨 윤리적으로 운영하는 기업을 선호합니다.',
  },
};
